import React from 'react';
import dateformat from 'dateformat';
import ViewForm from './ViewForm';
import DynamicTable from '@atlaskit/dynamic-table';
import {GridColumn} from '@atlaskit/page';
import {useTranslation} from 'react-i18next';

export default ({fetching, billing, permissions}) => {
  const {t} = useTranslation('clients');

  return permissions ? (
    <ViewForm
      formName='billing'
      title={t('Billing')}
      fetching={fetching}
    >
      <GridColumn medium={12}>
        <br/>
        <DynamicTable
          head={HEAD(t)}
          rows={buildRows(billing)}
          rowsPerPage={undefined}
          defaultPage={1}
        />
      </GridColumn>
    </ViewForm>
  ) : null
};

const HEAD = t => ({
  cells: [
    {
      key: 'id',
      content: t('clients:#'),
      isSortable: false,
      width: '30px',
    },
    {
      key: 'tariff',
      content: t('clients:BillingTariff'),
      isSortable: false,
      width: undefined,
    },
    {
      key: 'dateStart',
      content: t('clients:BillingDateStart'),
      isSortable: false,
      width: '160px',
    },
    {
      key: 'dateEnd',
      content: t('clients:BillingDateEnd'),
      isSortable: false,
      width: '160px',
    },
    {
      key: 'status',
      content: t('clients:BillingStatus'),
      isSortable: false,
      width: '90px',
    },
  ],
});

const buildRows = (data) => (
  data?.map((item, index) => ({
    key: `row-${index}-${item.id}`,
    cells: [
      {content: item.id},
      {content: item.tariff},
      {content: dateformat(item.dateStart, 'dd.mm.yyyy')},
      {content: dateformat(item.dateEnd, 'dd.mm.yyyy')},
      {content: item.status},
    ],
  }))
);
